var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eden-page-header',{attrs:{"title":'Cleaner Directory',"subtitle":'Edit Cleaner Profile'}}),(_vm.cleaner.id)?_c('cleaner-form',{attrs:{"action":'edit',"cleaner":_vm.cleaner}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }